module.exports = __webpack_public_path__ + "static/media/C008.cbb2a795.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C008.jpg
// module id = 291
// module chunks = 0